import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import styles from './modalizer.scss'
import iconClose from '../../assets/global/global_close.svg'
import themeTypes from 'helpers/enums/themes/themeTypes'
import getThemeClassResolver from 'helpers/themes/themeClassResolver'

class Modalizer extends PureComponent {

	constructor() {
		super()
		this.handleKeyUp = this.handleKeyUp.bind(this)
		this.modalKeyUp = this.modalKeyUp.bind(this)
	}

	handleKeyUp(ev) {
		if (ev.keyCode === 13) {
			this.props.closeAction()
		}
	}

	modalKeyUp(ev) {
		if (ev.keyCode === 27) {
			this.props.closeAction()
		}
	}

	componentDidMount() {
		document.addEventListener('keydown', this.modalKeyUp, false)
	}

	render() {
		return (
			<div styleName={classNames({
				modalizer: true,
			})}
			>
				<div
					styleName={classNames({
						modalizer_veil: true,
						'modalizer_veil--absolute': !this.props.isTopLayer,
					})}
					onTouchEnd={e => {
						if (this.props.canCloseOnVeil) {
							e.preventDefault()
							this.props.closeAction()
						}
					}}
					onClick={this.props.canCloseOnVeil ? this.props.closeAction : null}>
				</div>
				<div
					styleName={classNames({
						container: true,
						'modalizer-box': this.props.boxed,
						nopadding: this.props.nopadding,
						...getThemeClassResolver([themeTypes.DARK], 'modalizer--', this.props.theme),
					})}
					style={{
						width: this.props.width,
						height: this.props.height,
					}}>
					{ this.props.closeButton &&
							<div
								tabIndex={200}
								onKeyUp={this.handleKeyUp}
								className={styles.modalizer_close}
								onClick={this.props.closeAction}
							>
								<img src={iconClose} />
							</div>
					}
					{ this.props.children }
				</div>
			</div>
		)
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.modalKeyUp, false)
	}
}

Modalizer.defaultProps = {
	nopadding: false,
	boxed: true,
	closeButton: true,
	canCloseOnVeil: true,
	isTopLayer: true,
	closeAction: () => {},
	theme: themeTypes.LIGHT,
}

Modalizer.propTypes = {
	theme: PropTypes.oneOf([themeTypes.LIGHT, themeTypes.DARK]),
	isTopLayer: PropTypes.bool,
	closeAction: PropTypes.func,
	canCloseOnVeil: PropTypes.bool,
	boxed: PropTypes.bool,
	nopadding: PropTypes.bool,
	closeButton: PropTypes.bool,
	children: PropTypes.node,
	width: PropTypes.string,
	height: PropTypes.string,
}

export default CSSModules(Modalizer, styles, {allowMultiple: true})
